import React from "react";
import PropTypes from "prop-types";
import ReadOnlyField from "./ReadOnlyField";

const PatternKeisouView = ({
  documentCategoryText,
  documentTypeText,
  productNo,
  productModel,
  destination,
  customer,
  varietyName,
  issueDate,
  assignee,
  remarks,
}) => {
  const renderSelect = (label, text) => (
    <div className="form-row">
      <span className="form-label">{label}</span>
      <div className="form-value read-only-select">
        <select className="form-select" disabled>
          <option value="">{text || ""}</option>
        </select>
      </div>
    </div>
  );

  return (
    <div className="pattern-form">
      <div className="form-grid">
        <ReadOnlyField label="製番" value={productNo} />
        <ReadOnlyField label="担当者" value={assignee} />
        {renderSelect("図面種類（計装・システム制御）", documentCategoryText)}
        <ReadOnlyField label="型式" value={productModel} />
        <ReadOnlyField label="仕向先" value={destination} />
        {renderSelect("図面タイプ（計装・システム制御）", documentTypeText)}
        <ReadOnlyField label="得意先" value={customer} />
        <ReadOnlyField label="品種名" value={varietyName} />
        <ReadOnlyField label="日付" value={issueDate} />
        <ReadOnlyField label="備考" value={remarks} />
      </div>
    </div>
  );
};

PatternKeisouView.propTypes = {
  documentCategoryText: PropTypes.string,
  documentTypeText: PropTypes.string,
  productNo: PropTypes.string,
  productModel: PropTypes.string,
  destination: PropTypes.string,
  customer: PropTypes.string,
  varietyName: PropTypes.string,
  issueDate: PropTypes.string,
  assignee: PropTypes.string,
  remarks: PropTypes.string,
};

PatternKeisouView.defaultProps = {
  documentCategoryText: "",
  documentTypeText: "",
  productNo: "",
  productModel: "",
  destination: "",
  customer: "",
  varietyName: "",
  issueDate: "",
  assignee: "",
  remarks: "",
};

export default PatternKeisouView;
